import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';
import {
  getLanguageFromLocalStorage,
  resolveSupportedLanguage,
} from './app.i18n';

/**
 * True when the request targets the API host. Compares URL *origins* rather than
 * a raw string prefix, so a look-alike host (e.g. `api.example.com.evil.com`)
 * can't slip through and receive the header. Relative URLs resolve against the
 * document base, so app-origin asset requests don't match a cross-origin API.
 */
const isApiRequest = (url: string): boolean => {
  try {
    return (
      new URL(url, document.baseURI).origin ===
      new URL(environment.appApiUrl).origin
    );
  } catch {
    return false;
  }
};

/**
 * Forwards the active platform (UI) language to the API as an `x-language`
 * header so core-ai can drive the conversational language. Scoped to the API
 * origin so the header never leaks to third-party hosts (e.g. speech-to-text).
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  const language = resolveSupportedLanguage(
    getLanguageFromLocalStorage(),
    environment.defaultLanguage,
  );

  return next(req.clone({ setHeaders: { 'x-language': language } }));
};
